import styled from 'styled-components'
import LogoTmovParceiros from '../../../../shared/assets/images/logo_parceiros.svg'
import { Tokens } from '@tmov/design-system/theme/types'

export { Button, CheckBox, Typography, TextField } from '@tmov/design-system'
export { Refresh, WaveVariantE } from '@tmov/design-system/icons'

const { colors } = Tokens.eixods

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 32px;
  overflow: auto;
`
export const Header = styled.img.attrs({
  src: LogoTmovParceiros,
  alt: 'Logo tmov parceiros',
})`
  width: 360px;
  height: 60px;
  object-fit: cover;
  margin: 40px auto 0;
`
export const Main = styled.div`
  max-width: 450px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  text-align: center;
  & > p {
    color: ${colors.brand.secondary[70]};
  }
  & > button {
    color: ${colors.neutral.grey[70]};
    &:hover {
      color: ${colors.neutral.grey[100]};
    }
  }
`
export const Action = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 24px;
  button {
    width: 120px;
  }
`

export const Error = styled.span`
  font-size: 14px;
  color: ${colors.feedback.error};
`
